<app-b2b-banner [data]="data"></app-b2b-banner>
<app-ice-images *ngIf="data" [data]="data"></app-ice-images>
<app-b2b-products *ngIf="dataPurifiers" [data]="dataPurifiers" [lang]="lang"></app-b2b-products>
<app-b2b-format *ngIf="data" [data]="data"></app-b2b-format>
<app-b2b-benefits *ngIf="data" [data]="data"></app-b2b-benefits>
<app-b2b-model *ngIf="data" [data]="data"></app-b2b-model>
<app-b2b-form></app-b2b-form>